import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';

import {ExchangeService} from '../../../services/api/exchange.service';
import {ExchangeActions} from '../../actions/exchange.actions';

@Injectable()
export class EditProposalEffects {

  proposalEditRequested = createEffect(() => {
    return this.actions.pipe(
      ofType(ExchangeActions.proposal.update),
      switchMap(action => {
        return this.vendorProposalService.editProposal(action.id, action.proposal).pipe(
          map(() => ExchangeActions.proposal.updateSuccess()),
          catchError(error => of(ExchangeActions.proposal.updateFail({error})))
        );
      })
    );
  });

  constructor(private actions: Actions,
              private vendorProposalService: ExchangeService) {
  }

}
